export default "__VITE_ASSET__Bpiz1aaH__"